import {handleEmailSending} from "../../helpers/email/emailHelper.ts";
import {fromCharCode} from "@opay/lib-core-js";

const OpayPrivacyContactEmail = () => {

    const name = fromCharCode(112, 114, 105, 118, 97, 99, 121);
    const domain = fromCharCode(111, 112, 97, 121, 46, 101, 117);

    return (
        <>
            <a className="contact-by-email" href='#' onClick={(e) => handleEmailSending(e, name, domain)}>
                {`${fromCharCode(112, 114, 105, 118, 97, 99, 121, 64, 111, 112, 97, 121, 46, 101, 117)}`}
            </a>
        </>
    )
}

export default OpayPrivacyContactEmail;
